// DraggableItem.tsx
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { MamClipElement } from '../../../types/clipTypes';
import {Box, useTheme} from '@mui/material';
import CardClipComponent from "../CardClipComponent/CardClipComponent";

interface DraggableItemProps {
    id: string;
    content: MamClipElement;
    deleteClipDraggable?: (id: string) => void;
    viewTag?: boolean;
    checkedTemplate?: boolean;
    handleCheckTemplate?: (id: string) => void;
    mode?: "template" | "asset";
}

const DraggableItem = ({ id, content, deleteClipDraggable, viewTag = true, checkedTemplate , handleCheckTemplate, mode }: DraggableItemProps) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id });

    const theme = useTheme();

    const draggableListVisibleFields = [
        "title",
        "competition",
        "match",
        "key_moment_type",
        "thumbnail",
        "aspect_ratio",
        'sort_date'
    ];

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        cursor: 'grab',
        margin: '0 8px',
    };

    return (
        <Box
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            sx={{
                flex: '0 0 auto', // Prevents flex items from shrinking
                boxSizing: 'border-box', // Ensures padding and borders are included in width
                [theme.breakpoints.up('xs')]: {
                    width: '100%', // xs={12} in Grid
                },
                [theme.breakpoints.up('sm')]: {
                    width: '50%', // sm={6} in Grid
                },
                [theme.breakpoints.up('md')]: {
                    width: '33.3333%', // md={4} in Grid
                },
                [theme.breakpoints.up('lg')]: {
                    width: '25%', // lg={3} in Grid
                },
                [theme.breakpoints.up('xl')]: {
                    width: '16.6667%', // xl={2} in Grid
                },
            }}
        >



            <CardClipComponent mode={mode} viewTag={viewTag} handleCheckTemplate={handleCheckTemplate} groupClip={content} handleVideoPlayerURL={()=>{}} handleOpenVideoPlayerURL={()=>{}} deleteClip={()=>{}} addGroupClip={()=>{}} isDraggable={true} deleteClipDraggable={deleteClipDraggable} idClipSelectedTemplate={checkedTemplate}  />
        </Box>

    );
};

export default DraggableItem;
